module.exports = __webpack_public_path__ + "img/Apple-Watch.0cfae92e.png";